import React, { Component } from 'react'
import styled, { css } from 'styled-components'
import { getTheme } from '../../global/utils'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faInfoCircle,
  faCheck,
  faExclamationTriangle
} from '@fortawesome/free-solid-svg-icons'

const AlertWrapper = styled.div`
  display: flex;
  border: 1px solid ${getTheme('textColor', 'baseLight')};
  border-left: 4px solid;
  border-radius: 0 ${getTheme('radius', 'm')} ${getTheme('radius', 'm')} 0;
  padding: ${getTheme('padding', 'verticalM')}
    ${getTheme('padding', 'horizontalM')};
  margin-bottom: ${getTheme('marginBottom', 'l')};

  .icon {
    flex-shrink: 0;
    margin-right: ${getTheme('spacer', 'xs')};
  }

  .message {
    padding-left: ${getTheme('padding', 'horizontalXS')};
  }

  ${props =>
    props.error &&
    css`
      border-left-color: ${getTheme('textColor', 'error')};
      .icon {
        color: ${getTheme('textColor', 'error')};
      }
    `};

  ${props =>
    props.success &&
    css`
      color: ${getTheme('textColor', 'success')};
    `};
`

class Alert extends Component {
  render() {
    const success = this.props.success
    const error = this.props.error
    let tipIcon = <FontAwesomeIcon icon={faInfoCircle} />

    if (success) {
      tipIcon = <FontAwesomeIcon icon={faCheck} />
    }
    if (error) {
      tipIcon = <FontAwesomeIcon icon={faExclamationTriangle} />
    }
    return (
      <AlertWrapper success={this.props.success} error={this.props.error}>
        <div className="icon">{tipIcon}</div>
        <div className="message">{this.props.children}</div>
      </AlertWrapper>
    )
  }
}

export default Alert



// WEBPACK FOOTER //
// ./src/components/shared/Alert.js